import { createApplicationFormSelector } from './createApplicationFormSelector';

export const selectLivingAddressObject = (state) => {
  return createApplicationFormSelector(state, 'living_address') || {};
};
